"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when graphql query is malformed
 * @param {string} reason
 */
class MalformedGraphQLQueryError extends ExtendableError_1.default {
    constructor(reason) {
        super(`Malformed GraphQL Query: ${reason}`);
        this.reason = reason;
    }
}
exports.default = MalformedGraphQLQueryError;
